import React from "react";

import { FastfoodRounded } from "@mui/icons-material";
import { Box, ButtonBase } from "@mui/material";

import { GreyPallet } from "../../../../../../../../config/styles";

import MainText from "../../../../../../../../components/MainText";
import useModal from "../../../../../../../../config/context/modalContext";
import { UtilComponents } from "../../../../../../../../config/util/utilComponents";
import { CafeteriaFoodItemType } from "../../../../../../../../types/database";

type FoodItemProps = {
  item: CafeteriaFoodItemType;
  amount: number;
  addItem: (item: CafeteriaFoodItemType) => void;
  removeItem: (item: CafeteriaFoodItemType) => void;
};

export default function FoodItem({ item, amount, addItem, removeItem }: FoodItemProps) {
  const { showImage } = useModal();

  React.useEffect(() => {}, []);

  return (
    <Box
      display="flex"
      justifyContent={"start"}
      alignItems={"center"}
      gap={1}
      mt={2}
      width={"100%"}
      sx={{ opacity: item.available ? 1 : 0.5 }}
    >
      <Box>
        <ButtonBase
          onClick={() => !!item?.image && showImage(item.image.resource)}
          style={{
            width: 38,
            height: 38,
            borderRadius: 19,
            backgroundColor: GreyPallet.LightGhost,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: GreyPallet.Regular,
            overflow: "hidden",
          }}
        >
          {item.image ? (
            <img
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              src={item.image.resource}
            />
          ) : (
            <FastfoodRounded sx={{ width: "20px" }} />
          )}
        </ButtonBase>
      </Box>

      <Box sx={{ flex: 1, textDecoration: item.available ? "inherit" : "line-through" }}>
        <MainText size="caption">{item.name}</MainText>
        <MainText color="regular" size="small">
          {item.description}
        </MainText>
      </Box>

      <Box
        display={"flex"}
        justifyContent={"center"}
        flexDirection={"column"}
        alignItems={"center"}
      >
        <Box sx={{ textAlign: "right", "& *": { whiteSpace: "nowrap" } }}>
          <MainText size="body" inline>
            {UtilComponents.toPrice(item.price)}
          </MainText>
        </Box>
        {/* <Box
          sx={{
            borderRadius: 5,
            backgroundColor: GreyPallet.LightGhost,
            display: "flex",
            alignItems: "center",
            textAlign: "sub",
          }}
        >
          <IconButton
            disabled={!item.available}
            sx={{ width: 30, height: 30 }}
            onClick={() => removeItem(item)}
          >
            -
          </IconButton>
          {item.available ? (
            <MainText>{amount}</MainText>
          ) : (
            <NoFoodRounded sx={{ fontSize: "14px" }} />
          )}
          <IconButton
            disabled={!item.available}
            sx={{ width: 30, height: 30 }}
            onClick={() => addItem(item)}
          >
            +
          </IconButton>
        </Box> */}
      </Box>
    </Box>
  );
}
